<template>
  <div class="inner-content">
    <div v-if="!isLoading && detail !== undefined">
      <h2 class="ttl-news-detail" data-private>{{ detail.title }}</h2>
      <p class="txt-news-date">{{ detail.sending_time }}</p>
      <div class="txt-new-body d-inline-block w-100 mb20" data-private>
        <div class="txt-news-content mb-3" v-html="detail.content"></div>
        <div v-if="detail.files.length > 0" class="txt-news-list-file">
          <a
            class="icon_document mr-4"
            v-for="(file, index) in detail.files"
            :key="index"
            :href="file.access_url"
            target="_blank"
          >
            {{ getFileName(file.access_url) }}
          </a>
        </div>
      </div>
      <div class="btn-cancel">
        <router-link :to="'/notifications/region'"><p>{{ $t('back_to_index') }}</p></router-link>
      </div>
    </div>
    <Spinner :isLoading="isLoading"/>
    <!-- MODAL NOTICE NOT FOUND -->
		<NotFoundDialog modalId="notice-detail-undefined" :content="$t('i_do_not_find_this_notification')" backToPath="/notifications/region" />
		<!-- MODAL -->
  </div>
</template>

<script>
import { mapState } from "vuex"
import Spinner from '@/js/components/Spinner'
import { BModal, VBModal, BButton} from 'bootstrap-vue'
import NotFoundDialog from '@/js/components/Common/NotFoundDialog'
export default {
  components: {
    BModal,
    VBModal,
    BButton,
    Spinner,
    NotFoundDialog
  },
  data() {
    return {
      detail: null,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      notificationsRegion: state => state.notification.notificationsRegion,
    })
  },
  async created() {
    this.screenTracking(this.$t('information_details'))
    this.isLoading = true
    if(this.notificationsRegion.length == 0) {
      await this.$store.dispatch('notification/getNotifications', 'region')
        .catch(err => {
          err.response.status == 401 ? this.$router.push('/404') : null
          return
        })
    }
    this.detail = this.notificationsRegion.find(n => n.id === this.$route.params.id)
    if( this.detail === undefined) {
      this.$bvModal.show('notice-detail-undefined')
    }
    else {
      if (this.detail.viewed_flg == 0) {
        this.detail.viewed_flg = 1
        this.$store.dispatch('notification/updateViewedNotification', this.detail.id)
          .catch(err => {
            err.response.status == 401 ? this.$router.push('/404') : null
            return
          })
      }
      let numberNoticeUnread = this.notificationsRegion.filter(notice => notice.viewed_flg == 0).length
      if (numberNoticeUnread == 0) {
        this.$store.dispatch('notification/setViewedFlg', false)
      }
      if(this.isLinkFile(this.detail)) {
        window.open(this.detail.files[0].access_url, '_self');
        return
      }
    }
    this.isLoading = false
  },
  methods: {
    isLinkFile (item) {
      if(!item.content && item?.files?.length == 1) {
        return true
      }
      return false
    },
    getFileName(file) {
      let fullName = file.substring(file.lastIndexOf("/")+1)
      if (fullName.indexOf('-') < 0) {
        return fullName
      }
      else {
        return decodeURIComponent(fullName.substring(fullName.indexOf('-')+1, fullName.indexOf('?X-Amz-Content-Sha')))
      }
    },
  }
}
</script>

<style scoped>
  .txt-news-content {
    display: flow-root;
  }
  .txt-news-list-file {
    display: grid;
  }
  .txt-news-list-file a {
    word-wrap: break-word;
    display: inline-flex;
    margin-bottom: 10px;
    background-size: 24px 26px;
    padding-left: 30px ;
    color: black;
  }
  .txt-news-list-file a:hover {
    color: black;
  }
</style>
